import { GridHeader } from './../../tracking-overview/interfaces/grid';


export const specimenTypeColumn: GridHeader = {
    displayText: 'Specimen Type',
    key: 'specimenType',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const specimenManagementStatusColumn: GridHeader = {
    displayText: 'Specimen Management Status',
    key: 'sampleStatus',
    sort: null,
    enableFilter: true,
    enableSearch: true
};

export const daysWithActiveeQuery: GridHeader = {
    displayText: 'Days with Active eQuery',
    key: 'daysOpen',
    sort: null,
    enableFilter: true,
    enableSearch: true,
};

export const eQueryType: GridHeader = {
    displayText: 'eQuery Type',
    key: 'eQueryType',
    enableFilter: true,
    enableSearch: true,
};

export const numberOfSamplesEffectedByEquery: GridHeader = {
    displayText: 'Number of Samples Affected By eQuery',
    key: 'samplesEffectedByQuery',
    enableFilter: true,
    enableSearch: true,
};

export const eQueryOpenDate: GridHeader = {
    displayText: 'Date eQuery was Opened',
    key: 'eQueryOpenDate',
    sort: null,
    enableFilter: true,
    enableSearch: true,
    isDate: true,
};